// Lenis-aware smooth scroll to a section id. Falls back to native scrollIntoView.
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset: -8 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
